<app-dialog-template>
  <app-dialog-template-header>
    <app-dialog-template-title>
      <ng-container>
        {{ 'OBJECTS.OBJECT_TYPES.PRINT_FORM' | translate }}
      </ng-container>
    </app-dialog-template-title>
    <app-dialog-template-header-actions></app-dialog-template-header-actions>
  </app-dialog-template-header>
  <app-dialog-template-body [hasSpaceY]="false">
    <app-bui-progress-spinner *ngIf="showProgressSpinner"
      [isActive]="showProgressSpinner"
      [spinnerHasOverlay]="true"
      [progressValue]="progressBarValue">
    </app-bui-progress-spinner>
    <div class="c-object-print-templates-dialog__icon-wrapper">
      <span class="c-object-print-templates-dialog__download-icon"
        (click)="downloadJsonDataSource()">
        <app-svg-icon [icon]="'json_file_icon'"></app-svg-icon>
      </span>
    </div>
    <div class="c-object-print-templates-dialog__body-table">
      <app-items-table
        [showTableWrapper]="false"
        [objectDefinition]="objectDefinition"
        [items]="items"
        [filterRowVisible]="false"
        [filterHeaderVisible]="false"
        [groupPanelVisible]="false"
        [multiSelection]="false"
        [standalone]="false"
        [preventRowClick]="true"
        [mode]="ModeEnum.View"
        [height]="ItemsTableHeightTypeEnum.FULL"
        [preventDelete]="true"
        [showSelectAll]="false"
        (itemActionEvent)="onItemsAction($event)">
      </app-items-table>
    </div>
    <div
      *ngIf="selectedTemplate?.type === PrintTemplateTypeEnum.JASPER"
      class="c-object-print-templates-dialog__actions">
      <mat-radio-group [(ngModel)]="exportType">
        <div>
          {{ 'PRINT_TEMPLATE.PRINT_TO' | translate }}
        </div>
        <mat-radio-button
          *ngIf="isPdf"
          [value]="ExportTypeEnum.PDF">
          {{ 'PRINT_TEMPLATE.PDF' | translate }}
        </mat-radio-button>
        <mat-radio-button
          *ngIf="isDocx"
          [value]="ExportTypeEnum.DOCX">
          {{ 'PRINT_TEMPLATE.DOCX' | translate }}
        </mat-radio-button>
        <mat-radio-button
          *ngIf="isXlsx"
          [value]="ExportTypeEnum.XLSX">
          {{ 'PRINT_TEMPLATE.XLSX' | translate }}
        </mat-radio-button>
      </mat-radio-group>
      <app-bui-slide-toggle
        *ngIf="data.type === 'ITEMS' && data.printData.length > 1"
        [(ngModel)]="templatesMergedIntoPDF"
        [label]="'PRINT_TEMPLATE.MERGE_TEMPLATES_PDF' | translate"
        (ngModelChange)="onChangeTemplatesMerged($event)">
      </app-bui-slide-toggle>
      <div class="c-object-print-templates-dialog__actions_row">
        <app-bui-slide-toggle
          *ngIf="selectedTemplate?.type === PrintTemplateTypeEnum.JASPER"
          [(ngModel)]="isCyrillic"
          [label]="'PRINT_TEMPLATE.CYRILLIC' | translate"
          (ngModelChange)="onChangeIsCyrillic($event)">
        </app-bui-slide-toggle>
        <app-input-number
          [label]="'PRINT_TEMPLATE.CUSTOM_FIELDS_LEVEL' | translate"
          *ngIf="this.selectedTemplate?.printType==='GENERIC'"
          [formControl]="customFieldsLevelControl"
          [min]="2"
          [max]="6">
        </app-input-number>
      </div>
    </div>
  </app-dialog-template-body>
  <app-dialog-template-footer>
    <app-bui-button-label
      [comboStyle]="'outline'"
      (clickEvent)="closeDialog()">
      {{ 'POPUP_FILTER_LIST_DIALOG.CANCEL' | translate }}
    </app-bui-button-label>
    <app-bui-button-label
      [comboStyle]="DialogTemplateButtonComboStyleEnum.FILL_GRADIENT_1"
      (clickEvent)="onPrint()"
      [disabled]="!selectedTemplate">
      <ng-container *ngIf="this.data?.skipAutoDownload">
        {{ 'COMMON.SEND' | translate }}
      </ng-container>
      <ng-container *ngIf="!this.data?.skipAutoDownload">
        {{ 'DATA_GRID.PRINT' | translate }}
      </ng-container>
    </app-bui-button-label>
  </app-dialog-template-footer>
</app-dialog-template>
